export default __webpack_public_path__ + "static/media/channel_spreading.49594672.png";